import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { serverUrl } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import NewArrivalsNotificationModal from "@/_MiniApps/NewArrivalsNotification/NewArrivalsNotificationModal";
import useNotificationInterests from "./useNotificationInterest";
import useBoolean from "@hooks/useBoolean";
import { AuthPopupHOC, useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import banners from "@data/banners/login-pages/favorite.json";
import { useTranslation } from "@i18n";
import { useCMS } from "@hooks/useCMS";
import { useLang } from "@/common/Contexts/LanguageContext";
import { handleHasAccountEvent } from "@/utils/common";
import useCookieClient from "@hooks/useCookieClient";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
var AddToFavoriteButton = function AddToFavoriteButton(_ref) {
  var _favorites$includes;
  var postId = _ref.postId,
    className = _ref.className,
    g4_data = _ref.g4_data,
    _ref$renderFunction = _ref.renderFunction,
    renderFunction = _ref$renderFunction === void 0 ? null : _ref$renderFunction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useAuthActions = useAuthActions(),
    remote_togglePostToFavorite = _useAuthActions.remote_togglePostToFavorite;
  var _useSession = useSession(),
    user = _useSession.user,
    favorites = _useSession.favorites;
  var _useState = useState(favorites === null || favorites === void 0 ? void 0 : (_favorites$includes = favorites.includes) === null || _favorites$includes === void 0 ? void 0 : _favorites$includes.call(favorites, +postId)),
    isFavorite = _useState[0],
    setIsFavorite = _useState[1];
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useNotificationInter = useNotificationInterests(postId, isFavorite),
    tryOpenNotificationModal = _useNotificationInter.tryOpenNotificationModal,
    whatsModalOpen = _useNotificationInter.whatsModalOpen,
    closeWhatsModal = _useNotificationInter.closeWhatsModal;
  var _useBoolean = useBoolean(),
    thanksModalOpen = _useBoolean.value,
    openThanksModal = _useBoolean.setTrue;
  var handleFavoriteAction = function handleFavoriteAction(userData, isPendingActionCall) {
    remote_togglePostToFavorite(postId).then(function (isFav) {
      if (isPendingActionCall) {
        trackEvents("element_click", {
          element_name: "favorite",
          user_login_status: "true"
        });
      }
      if (isFav === true) {
        if (isPendingActionCall) {
          handleHasAccountEvent({
            hasAccount: userData.has_account,
            status: "Success",
            phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
            lang: lang,
            referral_location: "favorite"
          });
        }
        unbxdAnalytics({
          action: "add_favorites",
          query: "",
          url: serverUrl,
          requestId: "N.A",
          pid: postId
        });
        tryOpenNotificationModal();
        trackEvents("add_favorite", g4_data);
      }
    });
    setIsFavorite(!isFavorite);
  };
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("مرحبًا بك!"),
    description: t("سجل الدخول أو قم بإنشاء حساب الآن لتتمكن من إدارة قائمة المفضلة الخاصة بك.")
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "favorite",
        user_login_status: "false"
      });
    },
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    renderFunc: function renderFunc(checkAuth) {
      var favClickHandler = function favClickHandler() {
        return checkAuth(handleFavoriteAction);
      };
      if (renderFunction) return renderFunction(favClickHandler, isFavorite);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: twMerge("bg-white rounded-full shadow-md focus:outline-none transition-colors w-8 h-8 flex items-center justify-center flex-shrink-0", className),
        onClick: favClickHandler,
        role: "button"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: isFavorite ? "material-symbols--favorite-rounded" : "material-symbols--favorite-outline-rounded",
        width: 5,
        height: 5,
        className: "fill-current text-primary flex-shrink-0"
      })));
    }
  }), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: whatsModalOpen,
    onClose: function onClose() {
      if (!thanksModalOpen) {
        trackEvents("notification_popup_response", {
          uuid: getCookieClient("UUID"),
          user_id: (user === null || user === void 0 ? void 0 : user.phone_number) || null,
          popup_response: "No"
        });
      }
      closeWhatsModal();
    },
    oowh: true
  }, /*#__PURE__*/React.createElement(NewArrivalsNotificationModal, {
    onClose: closeWhatsModal,
    thanksModalOpen: thanksModalOpen,
    openThanksModal: openThanksModal
  })));
};
export default AddToFavoriteButton;